let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ifibj")).then(() => parcelRequire('fkv8d'));